import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/_authentication.service';
import { RouteNavigationService } from '@services/_routeNavigation.service';
import { delay } from '../_helpers/delay';
import { stringToBool } from '../_helpers/stringToBoolean';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
  public loggingOut = false;
  constructor(
    private authService: AuthenticationService,
    private routeNavService: RouteNavigationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.logout();
  }

  private getQueryItem(queryParamName: string): string {
    return this.route.snapshot.queryParams[queryParamName];
  }

  private async logout() {
    const logoutGuid: string = this.getQueryItem('logoutGuid');
    const revokeToken: boolean = stringToBool(this.getQueryItem('revokeToken'));
    const explicitSubDomainName: string = this.getQueryItem('explicitSubDomainName');
    const forceReloadAfterLogout: boolean = stringToBool(this.getQueryItem('forceReload'));

    if (
      this.authService.logoutPermitted &&
      logoutGuid === this.authService.logoutGuid
    ) {
      this.loggingOut = true;
      // Make sure logout loading page is visible for atleast 500ms to avoid fast changing glitchy looking UI
      await delay(500);
      this.authService.logoutStepTwo(revokeToken, explicitSubDomainName, forceReloadAfterLogout);
      return;
    }
    this.routeNavService.navigate('login');
  }
}
